import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { getServers} from "../../../actions/actionServer";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import ReactJson from 'react-json-view';
import { Progress } from 'reactstrap';
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Agent",path:"/agents",isActive: false},
    {name: "ViewAgent",path:"/viewagent",isActive: true},
];

class ViewServer extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentServer: null
        };
    }
  
    componentDidMount(){
        this.props.getServers();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.servers.length > 0){        	
            let currentServer = nextProps.servers.find(server => server.server_id === this.props.match.params.id);
            this.setState({currentServer: currentServer});
        }
    }

    formatSizeUnits(bytes){
      if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
      else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
      else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
      else if (bytes > 1)           { bytes = bytes + " bytes"; }
      else if (bytes == 1)          { bytes = bytes + " byte"; }
      else                          { bytes = "0 bytes"; }
      return bytes;
    }

    render(){
        const {currentServer} = this.state;
        return (
            <div className="profile-page">  
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                               <strong>View Agent</strong>
                                {currentServer ? <Link className="pull-right" to={{ pathname: `/updateagent/${currentServer.server_id}`}}>
                                    <Button size="sm" 
                                    className = "reset-btn"
                                    color="primary"> Edit Agent </Button> </Link> : " " }
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        {currentServer?
                                            <div className="agent-padding">
                                                <div className="text-left"><div className={currentServer.cpu_percent < 80 ? "box green":"box red"}></div>Core Utilization: <b>{currentServer.cpu_percent}% </b></div>
                                                <div className="text-left"><div className="box blue"></div>Core Allocation: <b>{Math.round(currentServer.core_calculations.percentage)}%  ({currentServer.core_calculations.used} of {currentServer.core_calculations.max} Cores) </b></div>
                                                {currentServer.cpu_percent < currentServer.core_calculations.percentage ?
                                                    (<Progress multi>
                                                        <Progress striped bar color={currentServer.cpu_percent < 80 ? "success":"danger"} value={currentServer.cpu_percent} />
                                                        <Progress striped bar color="info" value={currentServer.core_calculations.percentage - currentServer.cpu_percent} />
                                                    </Progress>)
                                                    :
                                                    (<Progress multi>
                                                        <Progress striped bar color="info" value={currentServer.core_calculations.percentage} />
                                                        <Progress striped bar color={currentServer.cpu_percent < 80 ? "success":"danger"} value={currentServer.cpu_percent - currentServer.core_calculations.percentage} />
                                                    </Progress>)}

                                                <div className="text-left"><div className={currentServer.memory_stats.percent < 80 ? "box green":"box red"}></div>Memory Utilization: <b>{currentServer.memory_stats.percent}% </b></div>
                                                <div className="text-left"><div className="box blue"></div>Memory Allocation: <b>{Math.round(currentServer.memory_calculations.percentage)}% ({this.formatSizeUnits(currentServer.memory_calculations.used)} of {this.formatSizeUnits(currentServer.memory_calculations.max)})</b></div>
                                                {currentServer.memory_stats.percent < currentServer.memory_calculations.percentage ?
                                                    (<Progress multi>
                                                        <Progress striped bar color={currentServer.memory_stats.percent < 80 ? "success":"danger"} value={currentServer.memory_stats.percent} />
                                                        <Progress striped bar color="info" value={currentServer.memory_calculations.percentage - currentServer.memory_stats.percent}/>
                                                    </Progress>)
                                                    :
                                                    (<Progress multi>
                                                        <Progress striped bar color="info" value={currentServer.memory_calculations.percentage} />
                                                        <Progress striped bar color={currentServer.memory_stats.percent < 80 ? "success":"danger"} value={currentServer.memory_stats.percent - currentServer.memory_calculations.percentage}/>
                                                    </Progress>)}

                                                <div className="text-left">Disk Usage: <b>{currentServer.disk_stats.percent}% </b></div>
                                                  <Progress striped color={currentServer.disk_stats.percent > 80 ? "danger" : "info"} value={currentServer.disk_stats.percent}></Progress>
                                                <br/>
                                            </div> :" "}
                                        <div className="profile-table">
                                            {currentServer?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Agent Id</h4></td><td>{currentServer.server_id ? currentServer.server_id : "-"}</td></tr>
                                                        <tr><td><h4>Hostname</h4></td><td>{currentServer.hostname ? currentServer.hostname : "-"}</td></tr>
                                                        <tr><td><h4>Enabled</h4></td><td><img src={currentServer.enabled ? iconYes : iconNo} alt="iconYes"/></td></tr>
                                                        <tr><td><h4>Automatically Prune Images</h4></td><td>{currentServer.prune_images_mode ? currentServer.prune_images_mode : "-"}</td></tr>
                                                        <tr><td><h4>Manager</h4></td><td>{currentServer.manager ? currentServer.manager.manager_hostname : ""}</td></tr>
                                                        <tr><td><h4>Zone</h4></td><td>{currentServer.manager ? currentServer.manager.zone_name : ""}</td></tr>
                                                        <tr><td><h4>Version</h4></td><td>{currentServer.agent_version ? currentServer.agent_version : "-"}</td></tr>
                                                        <tr><td><h4>Provider</h4></td><td>{currentServer.provider ? currentServer.provider : "-"}</td></tr>
                                                        <tr><td><h4>Instance Id</h4></td><td>{currentServer.instance_id ? currentServer.instance_id : "-"}</td></tr>
                                                        <tr><td><h4>Last Reported</h4></td><td>{currentServer.last_reported_elapsed}</td></tr>
                                                        <tr><td><h4>Last Reported Time</h4></td><td>{moment(currentServer.last_reported).isValid() ?moment(currentServer.last_reported).format("L h:mm A"): "-"}</td></tr>
                                                        <tr><td><h4>Operational Status</h4></td><td>{currentServer.operational_status ? currentServer.operational_status: "-"}</td></tr>
                                                        <tr><td><h4>CPU Cores</h4></td><td>{currentServer.cores ? currentServer.cores : "-"}</td></tr>
                                                        <tr><td><h4>CPU Cores Override</h4></td><td>{currentServer.cores_override ? currentServer.cores_override : "-"}</td></tr>
                                                        <tr><td><h4>Memory</h4></td><td>{currentServer.memory ? currentServer.memory : "-"}</td></tr>
                                                        <tr><td><h4>Memory Override</h4></td><td>{currentServer.memory_override ? currentServer.memory_override : "-"}</td></tr>
                                                        <tr><td><h4>Memory Stats</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.memory_stats}
                                                                name={false}
                                                                collapsed={true}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>

						        <tr><td><h4>GPU Info</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.gpu_info}
                                                                name={false}
                                                                collapsed={true}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>

                                                        <tr><td><h4>Network Interfaces</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.network_interfaces}
                                                                name={false}
                                                                collapsed={true}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Disk Stats</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.disk_stats}
                                                                name={false}
                                                                collapsed={true}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Live Sessions </h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.kasms}
                                                                name={false}
                                                                collapsed={true}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Docker Images</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.docker_images}
                                                                name={false}
                                                                collapsed={true}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Docker Info</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.docker_info}
                                                                name={false}
                                                                collapsed={true}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                        <tr><td><h4>Manager Details</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.manager}
                                                                name={false}
                                                                collapsed={true}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewServer.propTypes = {
    getServers: Proptypes.func.isRequired,
    servers: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        servers: state.servers.servers || []
    }),
dispatch => 
    ({  
        getServers: () => dispatch(getServers()),
    }))(ViewServer);



// WEBPACK FOOTER //
// ./src/views/Agents/ViewAgent/ViewServer.js